<template lang="pug">
b-dropdown.mobile-action-wrapper(aria-role="list")
  template(#trigger)
    .mobile-action-button(@click="onMobileAction")
      span.icon
        i.mdi.mdi-plus.mdi-24px    
  b-dropdown-item(aria-role="listitem" :focusable="false" @click="newAppointment(APPOINTMENT_TYPES.APPOINTMENT)") 
    span.is-size-4 
      span.icon.is-medium
        i.mdi.mdi-calendar
      span(v-t="'actions.new_appointment'")
  b-dropdown-item(aria-role="listitem" :focusable="false" @click="newAppointment(APPOINTMENT_TYPES.EVENT)") 
    span.is-size-4 
      span.icon.is-medium
        i.mdi.mdi-calendar
      span(v-t="'actions.new_group_event'")
  b-dropdown-item(aria-role="listitem" :focusable="false" @click="findSlot") 
    span.is-size-4 
      span.icon.is-medium
        i.mdi.mdi-table-search
      span(v-t="'appointment.actions.find_slot'")
  b-dropdown-item(aria-role="listitem" :focusable="false" @click="blockTime") 
    span.is-size-4 
      span.icon.is-medium
        i.mdi.mdi-close
      span(v-t="'appointment.actions.block_time'")
  b-dropdown-item(aria-role="listitem" :focusable="false" @click="newSale") 
    span.is-size-4 
      span.icon.is-medium
        i.mdi.mdi-cart-outline
      span(v-t="'sale.actions.new_sale'")
</template>
<script>
import {mapState} from 'vuex'
import CheckoutPopup from './checkout/CheckoutPopup'
import Checkout from './sale/Checkout'
// import CreateEditAppointment from './calendar/CreateEditAppointment'
import APPOINTMENT_TYPES from '../../constants/appointmentTypes'
import SlotFinder from './calendar/SlotFinder'
import BlockTimeModal from './calendar/BlockTimeModal.vue'

export default {
  name: 'MobileActionButton',

  props: {
    date: {type: Date, default: undefined},
    location: {type: String, required: true},
    scope: {type: String, default: undefined}
  },
  data() {
    return {
      APPOINTMENT_TYPES
    }
  },
  computed: {
    ...mapState('company', ['company'])
  },
  methods: {
    newAppointment(type) {
      this.$emit('onAppointment', {startDate: this.date, locationId: this.location, type})
    },
    findSlot() {
      this.$buefy.modal.open({
        parent: this,
        component: SlotFinder,
        hasModalCard: true,
        fullScreen: true,
        canCancel: ['escape'],
        events: {
          input: ({services, start, locationId}) => {
            this.$emit('onAppointment', {
              startDate: start,
              locationId,
              initialServices: services,
              type: APPOINTMENT_TYPES.APPOINTMENT
            })
          }
        }
      })
    },
    blockTime() {
      this.$buefy.modal.open({
        parent: this,
        component: BlockTimeModal,
        props: {date: this.date, locationId: this.location, scope: this.scope},
        fullScreen: this.isMobile(),
        hasModalCard: true,
        canCancel: ['escape']
      })
    },
    newSale() {
      if (this.company.rewardsOnly) {
        this.$buefy.modal.open({
          parent: this,
          component: CheckoutPopup,
          fullScreen: true,
          canCancel: ['escape']
        })
      } else {
        this.$buefy.modal.open({
          parent: this,
          component: Checkout,
          fullScreen: true,
          props: {locationId: this.location},
          hasModalCard: true,
          canCancel: ['escape']
        })
      }
    },
    onMobileAction(event) {
      if (!this.$rfSettings().calendar || this.company.rewardsOnly) {
        event.stopPropagation()
        return this.newSale()
      }
    }
  }
}
</script>
